<template>
  <div class="choiceWap">
    <div class="choice-title">
      <img src="../../assets/imgs/answer01.png" />
      <span class="adjustText">简答题</span>
    </div>
    <el-form :rules="objRules" :model="subjectObj" ref="subjectObj">
      <div class="editorWrap question stem">
        <el-form-item label="分数：" prop="score">
          <el-input name="score" class="subject-score" v-model="subjectObj.score" @keyup.native="checkScore" @keydown.native="checkScore"></el-input>
        </el-form-item>
        <div class="editorWrap-write">
          <div class="editorChild">题干：</div>
          <TinymceEditor v-model="questionContent.content" ref="questionQuillEditor">
          </TinymceEditor>
        </div>
        <div class="uploadArea">
          <el-upload action="" :http-request="fnUploadRequest" list-type="picture" name="files" :data="{filename: 'files'}"
            :before-remove="(file, fileList)=>beforeFileRemove('question', '', file, fileList)" :before-upload="(file)=>beforeFileUpload('question', file, '')"
            :on-success="(res, file)=>handleUploadSuccess('question', '', res, file)" :on-remove="(file, fileList)=>handleFileRemove('question', '', file, fileList)"
            :file-list="questionFiles" :limit="3" accept=".jpg,.png,.jpeg,.zif">
            <el-button type="info" size="mini">
              <i class="el-icon-plus icon-plus"></i>
              <span class="icon-text">上传附件</span>
            </el-button>
          </el-upload>
          <span class="tips">温馨提示：请根据题目需要上传附件，最多可上传3个</span>
        </div>
      </div>
      <span class="subline"></span>
      <div class="editorWrap answer">
        <div class="edit-analysis" style="display: flex;justify-content: start;">
          <div class="editorChild">答案：</div>
          <textarea v-model="answerContent.content" class="option-textarea" placeholder="请输入答案"></textarea>
        </div>

      </div>
      <span class="subline"></span>
      <div class="editorWrap edit-analysis last-editor">
        <div style="display: flex;justify-content: start;">
          <div class="editorChild">解析：</div>
          <textarea v-model="analysisContent.content" class="analysis-textarea" placeholder="设置题目解析，非必填..."></textarea>
        </div>
        <div class="uploadArea">
          <el-upload action="" :http-request="fnUploadRequest" list-type="picture" name="files" :data="{filename: 'files'}"
            :before-remove="(file, fileList)=>beforeFileRemove('analysis', '', file, fileList)" :before-upload="(file)=>beforeFileUpload('analysis', file, '')"
            :on-success="(res, file)=>handleUploadSuccess('analysis','', res, file)" :on-remove="(file, fileList)=>handleFileRemove('analysis','', file, fileList)"
            :file-list="analysisFiles" :limit="3" accept=".jpg,.png,.jpeg,.zif">
            <el-button type="info" size="mini">
              <i class="el-icon-plus icon-plus"></i>
              <span class="icon-text">上传附件</span>
            </el-button>
          </el-upload>
          <span class="tips">温馨提示：请根据题目需要上传附件，最多可上传3个</span>
        </div>
      </div>
      <el-collapse accordion v-model="subjectObj.visible">
        <el-collapse-item class="set-attr" :name="1">
          <template slot="title">
            <span style="padding-left: 45px;">活动属性</span>
          </template>
          <div class="question-attr">
            <el-form-item label="经验值" prop="exp">
              <el-input v-model.trim="subjectObj.exp" size="small"></el-input>
            </el-form-item>
            <el-form-item label="积分" prop="bp">
              <el-input v-model.trim="subjectObj.bp" size="small"></el-input>
            </el-form-item>
            <el-form-item label="标签" class="not-must">
              <el-tag :key="tag" v-for="tag in subjectObj.tags" closable :disable-transitions="false" @close="handleClose(tag, 'subject')">
                {{tag}}
              </el-tag>
              <el-input class="input-new-tag" v-if="tagVisible" v-model.trim="tagValue" :maxlength="10" ref="saveTagInput" size="small"
                @keyup.enter.native="handleInputConfirm('subject')" @blur="handleInputConfirm('subject')">
              </el-input>
              <el-button v-else class="button-new-tag" size="small" @click="showTagInput('subject')">+ 标签</el-button>
            </el-form-item>
            <el-form-item label="难度">
              <el-radio-group label="难度" v-model="subjectObj.difficulty">
                <el-radio :label="1">简单</el-radio>
                <el-radio :label="2">一般</el-radio>
                <el-radio :label="3">困难</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </el-collapse-item>
      </el-collapse>
      <div class="bottoma general-preview">
        <el-col :span="24">
          <el-button type="primary" @click="saveChoice('subjectObj')">保存</el-button>
          <el-button type="info" plain>预览</el-button>
        </el-col>
      </div>
    </el-form>
  </div>
</template>

<script>
import oss from '@/utils/aliOss'
import { savePaperTopicContent } from "@/api/contest";
import TinymceEditor from "@/components/test/TinymceEditor-txt";

export default {
  components: {
    TinymceEditor
  },
  props: ['paperId', 'contentId', 'editorData'],
  beforeDestroy() {
  },
  mounted() {
    this.fetchData()
  },
  watch: {
    paperId: function () {
      this.id = this.paperId
    },
    contentId: function () {
      this.fetchData()
    }
  },
  computed: {
  },
  data() {
    const validator = function (rule, value, callback) {
      let errors = [];
      if (!/^[0-9]+$/.test(value)) {
        callback('请输入0-100以内的正整数!');
      }
      if (value > 100 || value < 0) {
        callback('请输入0-100以内的正整数!');
      }
      callback(errors);
    };
    return {
      id: this.paperId,
      uploadApi: '/test/ossUpload',
      uploadDialogVisible: false,
      subjectTitle: '',
      subjectScore: '',//分数
      subjectStatus: 1, //1-完整 2-草稿
      dialogTitle: '',
      curImageUrl: '',
      optionMap: {
        0: 'A', 1: 'B', 2: 'C', 3: 'D', 4: 'E', 5: 'F', 6: 'G', 7: 'H',
      },
      questionContent: {
        type: 8,
        content: '',
        file: [], // filename\name url filetype
      },
      answerContent: {
        content: '',
        file: [],
      },
      analysisContent: {
        content: '',
        file: [],
      },
      answerFiles: [],
      analysisFiles: [],
      questionFiles: [],
      answerEditorOption: {
        placeholder: '设置答案...',
        modules: {
          toolbar: '#answerToolbar',
        },
      },
      analysisEditorOption: {
        placeholder: '设置题目解析, 非必填...',
        modules: {
          toolbar: '#analysisToolbar',
        },
      },
      isAnalysis: false,
      subjectObj: {
        content_id: this.contentId,
        title: '',
        score: 10,
        visible: 0,
        bp: 5,
        exp: 5,
        tags: [],
        difficulty: 2,
      },
      tagVisible: false,
      tagValue: '', //标签值
      objRules: {
        score: [
          { required: true, message: '请输入分数！', trigger: 'blur' },
          {
            validator(rule, value, callback, source, options) {
              var errors = [];
              if (value > 150 || value < 0 || value === '') {
                callback('请输入0-150以内的数字!');
              }
              if (!/^[\d\.]*$/.test(value)) {
                callback('请输入0-150以内的数字！');
              }
              if (!/^\d+(\.5?0{0,}|\.0)?$/.test(value)) {
                callback('小数只支持0.5的倍数！');
              }
              callback(errors);
            }
          }
        ],
        exp: [
          { required: true, validator: validator, trigger: 'blur' },
          { validator: validator, trigger: 'change' }
        ],
        bp: [
          { required: true, validator: validator, trigger: 'blur' },
          { validator: validator, trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    //积分经验数字验证
    UpNumber(e) {
      e.target.value = e.target.value.replace(/[^\d]/g, ""); //限制输入正整数
    },
    //分数验证,有小数点，为0.5倍数
    checkScore(e) {
      e.target.value = e.target.value.replace(/[^\d\.]/g, ""); //限制输入正整数及小数点
    },
    restoreFilesList() {
      // analysisFiles questionFiles optionsFiles correspondFiles
      if (this.questionContent.file && this.questionContent.file.length > 0) {
        this.questionFiles = JSON.parse(JSON.stringify(this.questionContent.file))
      }
      if (this.answerContent.length > 0) {
        this.answerFiles = JSON.parse(JSON.stringify(this.answerContent.file))
      }
      if (this.analysisContent.file && this.analysisContent.file.length > 0) {
        this.analysisFiles = JSON.parse(JSON.stringify(this.analysisContent.file))
      }
    },
    // 附件图片上传前钩子
    beforeFileUpload(type, file) {
      const imgs = ['png', 'jpg', 'jpeg', 'gif'];
      const suffix = file.name.substring(file.name.lastIndexOf('.') + 1)
      const result = this.common.beforeUploadImg(type, file);
      if (!result.success) {
        this.$message.error(result.msg)
        return false
      } else {
        if (imgs.indexOf(suffix) == -1) {
          return file;
        }
        let _this = this
        const isSize = new Promise(function (resolve, reject) {
          let _URL = window.URL || window.webkitURL;
          let img = new Image();
          img.onload = function () {
            let valid = img.width <= 4096 && img.height <= 4096;
            valid ? resolve() : reject();
          }
          img.src = _URL.createObjectURL(file);
        }).then(() => {
          return file;
        }, () => {
          _this.$message.error('上传文件的图片宽度或者高度不能超过4096像素')
          return Promise.reject();
        });
        return isSize
      }
    },
    handleFileRemove(type, index, file, fileist) {
      if (type === 'question') {
        this.questionContent.file.splice(this.questionContent.file.indexOf(file.name), 1);
      }
      if (type === 'answer') {
        this.answerContent.file.splice(this.answerContent.file.indexOf(file.name), 1);
      }
      if (type === 'analysis') {
        this.analysisContent.file.splice(this.analysisContent.file.indexOf(file.name), 1);
      }
    },
    handleUploadSuccess(type, index, res, file) {
      if (!res) return
      // 去重校验 file.name
      if (res.res.status === 200) {
        const fileObj = {
          url: res.res.requestUrls[0].split('?')[0],
          filetype: file.raw.type,
          name: file.name
        }
        if (type === 'answer') {
          if (this.answerContent.hasOwnProperty('file')) {
            this.answerContent.file.push(fileObj)
          } else {
            this.answerContent.file = [];
            this.answerContent.file.push(fileObj)
          }
        }
        if (type === 'question') {
          if (this.questionContent.hasOwnProperty('file')) {
            this.questionContent.file.push(fileObj)
          } else {
            this.questionContent.file = [];
            this.questionContent.file.push(fileObj)
          }
        }
        if (type === 'analysis') {
          if (this.analysisContent.hasOwnProperty('file')) {
            this.analysisContent.file.push(fileObj)
          } else {
            this.analysisContent.file = [];
            this.analysisContent.file.push(fileObj)
          }
        }
      }
    },
    saveChoice(formName) {
      if (!this.questionContent.content) {
        this.$message('题干不能为空');
        return
      }
      if (!this.answerContent.content) {
        this.$message('答案不能为空');
        return
      }
      this.analysisContent.answer = this.answerContent  // @xavier add..

      let subject = {
        paper_content_id: this.subjectObj.content_id ? this.subjectObj.content_id : 0,
        paper_id: this.id,
        paper_type: this.questionContent.type,
        topic_title: this.questionContent,
        answer: this.analysisContent.answer,
        parsing: this.analysisContent,
        activity_attribute: this.subjectObj.visible,
        score: this.subjectObj.score,
        experience: this.subjectObj.exp,
        integral: this.subjectObj.bp,
        label: this.subjectObj.tags,
        difficulty: this.subjectObj.difficulty
      }
      sessionStorage.setItem('ShortAnswer', this.subjectObj.score)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          savePaperTopicContent(subject).then(response => {
            this.$message.success('保存成功')
            this.$root.$emit('returntopic', response.data)
          })
        }
      })


    },
    resetData() {
      this.subjectStatus = 1;
      this.subjectTitle = '';
      this.questionContent = {
        type: 8,
        content: '',
        file: [],
      };
      this.analysisContent = {};
      this.answerContent = {};
      this.isAnalysis = false;
      this.analysisFiles = [];
      this.questionFiles = [];
      this.answerFiles = [];
      this.subjectObj = {
        content_id: this.contentId,
        title: '',
        score: sessionStorage.getItem('ShortAnswer') ? sessionStorage.getItem('ShortAnswer') : 10,
        visible: 0,
        bp: 5,
        exp: 5,
        tags: [],
        difficulty: 2,
      }
    },
    // 打开上传的窗口
    openUploadDialog(type = 'image') {
      this.dialogTitle = '上传图片'
      this.uploadDialogVisible = true;
      //this.curImageUrl = URL.createObjectURL(file.raw);
    },
    // 点footer的取消不会触发
    beforeDialogClose(done) {
      this.$confirm('确认关闭？').then(_ => {
        done();
      }).catch(_ => { });

    },

    // 标签删除
    handleClose(tag, type = '') {
      if (type === 'activity') {
        this.activitySetting.tags.splice(this.activitySetting.tags.indexOf(tag), 1);
      }
      if (type === 'subject') {
        this.subjectObj.tags.splice(this.subjectObj.tags.indexOf(tag), 1);
      }
    },
    // 增加标签
    showTagInput(type = '') {
      if ((type === 'activity' && this.activitySetting.tags.length >= 5) ||
        (type === 'subject' && this.subjectObj.tags.length >= 5)) {
        this.$message('最多只能添加五个标签'); return;
      }
      this.tagVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    // 标签输入确认
    handleInputConfirm(type = '') {
      if (this.tagValue) {
        if (type === 'activity' && this.activitySetting.tags.indexOf(this.tagValue) === -1) {
          this.activitySetting.tags.push(this.tagValue);
        }
        if (type === 'subject' && this.subjectObj.tags.indexOf(this.tagValue) === -1) {
          this.subjectObj.tags.push(this.tagValue);
        }
      }
      this.tagVisible = false;
      this.tagValue = '';
    },
    fetchData() {
      this.resetData()
      if (this.editorData) {
        this.optionsContent = this.editorData.answer
        this.analysisContent = this.editorData.parsing
        this.questionContent = this.editorData.topic_title
        this.answerContent = this.editorData.parsing.answer
        this.subjectObj.visible = this.editorData.activity_attribute
        this.subjectObj.score = this.editorData.score
        this.subjectObj.exp = this.editorData.experience
        this.subjectObj.bp = this.editorData.integral
        this.subjectObj.tags = this.editorData.label
        this.subjectObj.difficulty = this.editorData.difficulty
        this.restoreFilesList()
      }
    },
    /**
  * @description [fnUploadRequest 覆盖默认的上传行为，实现自定义上传]
  * @param    {object}   option [上传选项]
  * @return   {null}   [没有返回]
  */
    async fnUploadRequest(option) {
      oss.ossUploadFile(option, 2)
    },
  },

}
</script>

<style scoped>
</style>